import { TaskType } from "gantt-task-react/dist/types/public-types"
import { DATA_TYPES } from "./StaticData"
import { AlertColor } from "@mui/material"
import { sampleData } from "../features/Quality/staticData"

interface IChildMenuItem {
  key: string
  label: string
  route?: string
  svg?: string
  child?: IChildMenuItem[]
}
interface IISPRTableColumn {
  id:
    | "feature"
    | "null_count"
    | "null_count_criteria"
    | "zero_count"
    | "zero_count_criteria"
    | "Zero_Count_Check"
    | "Null_Count_Check"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}
interface IWebScrapingColumn {
  id:
    | "websites"
    | "description"
    | "time"
    | "duration"
    | "status"
    | "pages"
    | "items"
    | "qcStatus"
    | "qcReview"
    | "errors"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface IMaintenanceColumn {
  id:
    | "usecase"
    | "market"
    | "pipelineName"
    | "lastExecuted"
    | "duration"
    | "status"
  // | "maintenance"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface IMaintenanceRunColumn {
  id: "pipelineRunIds" | "executionDate" | "duration" | "status"
  // | "maintenance"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}
interface IMaintenanceExecutionData {
  pipelineRunIds: string
  executionDate: string
  duration: string
  status: number
  start_time: string
  end_time: string
}
interface IStatus {
  icon: string
  text: string
  backgroundColor: string
  align?: string
}
interface IModelMetaDataColumn {
  id:
    | "CATEGORY_UPDATED"
    | "volume_mix"
    | "HM CC_after"
    | "HM CC_before"
    | "HM CT_after"
    | "HM CT_before"
    | "OP_after"
    | "OP_before"
    | "region"
  label: string
  minWidth?: number
  align?: "center" | "right"
  format?: (value: number) => string
}
interface IModelMetaData {
  category?: string
  region?: string
  Region?: string
  Category?: string
  ttbr: string
  ttar: string
  mtbr: string
  mtar: string
}

interface IAdmTableColumn {
  id:
    | "BASE_TABLE"
    | "COUNT_IN_BASE_TABLE"
    | "COUNT_OF_MAPPED"
    | "MATCH_VOLUME_PERCENTAGE"
    | "QC_STATUS"
    | "MAPPED_TABLE"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}
interface IRawDataDetailsTableColumn {
  id: "column" | "data_type" | "profiling" | "schema" | "quality_check"
  label: string
  minWidth?: number
  align?: "left" | "right"
  format?: (value: number) => string
}
interface IAdmTableData {
  BASE_TABLE: string
  COUNT_IN_BASE_TABLE: number
  MAPPED_TABLE: string
  COUNT_OF_MAPPED: number
  MATCH_VOLUME_PERCENTAGE: number
  QC_STATUS: string
}
interface IISQTableData {
  CHANNEL: string
  FEATURE: string
  NULL_COUNT: number
  NULL_COUNT_CRITERIA: string
  ZERO_COUNT: number
  ZERO_COUNT_CRITERIA: string
  NULL_COUNT_CHECK: string
  ZERO_COUNT_CHECK: string
  THEORETICAL_RANGE: string
  THEORETICAL_RANGE_CHECK: string
}
interface IDDCTableTableData {
  TABLE_NAME: string
  KPI: string
  MONTHLY_SUM: number
  LAST_12_MONTH_AVG: number
  PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG: number
  RESULT: string
  HARD_THRESHOLD_LOWER_LIMIT?: number
  HARD_THRESHOLD_UPPER_LIMIT?: number
  SOFT_THRESHOLD_LOWER_LIMIT?: number
  SOFT_THRESHOLD_UPPER_LIMIT?: number
}

interface IISQTableColumn {
  id:
    | "CHANNEL"
    | "FEATURE"
    | "NULL_COUNT"
    | "NULL_COUNT_CRITERIA"
    | "ZERO_COUNT"
    | "ZERO_COUNT_CRITERIA"
    | "NULL_COUNT_CHECK"
    | "ZERO_COUNT_CHECK"
    | "THEORETICAL_RANGE"
    | "THEORETICAL_RANGE_CHECK"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface IDDCTableColumn {
  id:
    | "TABLE_NAME"
    | "KPI"
    | "MONTHLY_SUM"
    | "LAST_12_MONTH_AVG"
    | "PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG"
    | "RESULT"
  label: string
  minWidth?: number
  width?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface ICCTableData {
  BASE_TABLE: string
  baseTableColumn: string
  SUM_IN_BASE_TABLE: number
  MAPPED_TABLE: string
  mappedTableColumn: string
  SUM_IN_MAPPED_TABLE: number
  MATCHED_VOULME: number
  QC_STATUS: string
}
interface ICCTableColumn {
  id:
    | "BASE_TABLE"
    | "baseTableColumn"
    | "SUM_IN_BASE_TABLE"
    | "MAPPED_TABLE"
    | "mappedTableColumn"
    | "SUM_IN_MAPPED_TABLE"
    | "MATCHED_VOULME"
    | "QC_STATUS"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface IFeatureDriftTableData {
  YEAR_MONTH: string
  CHANNEL: string
  FEATURE: string
  MONTHLY_SUM: number
  LAST_12_MONTH_AVG: string
  PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG: number
  WARNING_THRESHOLD: number
  highlight?: boolean
}
interface IFeatureDriftTableColumn {
  id:
    | "YEAR_MONTH"
    | "CHANNEL"
    | "FEATURE"
    | "MONTHLY_SUM"
    | "LAST_12_MONTH_AVG"
    | "PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG"
    | "WARNING_THRESHOLD"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}

interface IMetaDataCard {
  title: string
  passCount: number
  fail: number
  progress: number
  emailTrigger: boolean
  key: string
  toolTipText: string
  file_type?: string
  emailText?: string
}
interface IFeatureDriftCard {
  title: string
  progress: number
  key: string
  toolTipText: string
  file_type?: string
  emailText?: string
  warnings: number
}
interface IModelMetaDataCard {
  title: string
  percentage: string
  retrainingPercentage: string
  key: string
  payloadKey: string
}

interface IAlertStatus {
  msg: string
  status: AlertColor
  open: boolean
}

interface IParentMenuItem {
  key: string
  label: string
  child?: IChildMenuItem[]
  route?: string
  svg?: string
}

interface INavigationMenu {
  [key: string]: IParentMenuItem
}

interface IMonitorCardInterface {
  label: string
  decription: string
  score: number
  hasHighLow?: boolean
  percentage?: number
  svg?: string
  identifier: string
  runs: string
  percentageKey?: string
  executionStatusCode?: number
  pipelines?: string | number
}

interface IGantData {
  start: number // Assuming you are storing timestamps as numbers
  end: number
  completed: {
    amount: number
  }
  name: string
  extra: string
}

interface IGantChartSeriesDataType {
  name: string
  data: IGantData[]
}

interface IPipelineData {
  name: string
  value: string
  src?: string
  key?: string
  percentage?: number
}

interface IWorkflow {
  last_run: {
    execution_status: number
    id: number
    start_time: string
    end_time: string
  }
  name: string
  input: any[] // You can replace 'any' with a more specific type if needed
  output: any[] // You can replace 'any' with a more specific type if needed
  mapping: any[] // You can replace 'any' with a more specific type if needed
  id: number
  created_at: string
  updated_at: string
  is_industrialized: boolean
}

interface IUseCaseOptions {
  name: string
  workflows: IWorkflow[]
  id: number
}

interface IImageProps {
  path: string
  alt?: string
}

interface IDropDownOptions {
  value: string
  label: string
  isFixed?: boolean
  isDisabled?: boolean
}

interface INewPipeLineTab {
  key: string
  label: string
}

interface IAzureMonitorUsageObj {
  kpi: string
  timestamp: number
  value: number
}

interface IClusterMemoryChartData {
  clusterMemory: number[][]
  clusterLoad: number[][]
  clusterCached: number[][]
  clusterShared: number[][]
  loadProcs: number[][]
  loadCpus: number[][]
}

interface INewPipeLineObj {
  profiling: string
  tableName: string
  location: string
  recreate: string
  specialCharacter: string
  fileFormat: string
}
interface INewPipeLineColumn {
  key: string
  label: string
  type: DATA_TYPES
}
interface IDeepDiveData {
  data: {
    id: number
    name: string
    market_place: {
      id: number
      name: string
    }
    last_run: {
      id: number
      execution_status: number
      start_time: string
      end_time: string
      progress: number
      current_stage: string
      last_activity_completed: string
      current_stage_time: string
      pipeline: number
      input: any[] // You may want to define a proper type for 'input'
      output: any[] // You may want to define a proper type for 'output'
    }
  }
}
interface IParameter {
  name?: string
  default_value?: string
}
interface INewTableCellChangePayload {
  table: string
  rowIndex: number
  keyName: string
  value: any
}
interface IRawDataQuality {
  raw_data_name: string
  schema_check: string
  row_processed: number
  quality_check_unique: string
  quality_check_null: string
  quality_status: string
}
interface IISPRTableData {
  feature: string
  null_count: number
  null_count_criteria: string
  zero_count: number
  zero_count_criteria: string
  Zero_Count_Check: string
  Null_Count_Check: string
}
interface IWebScrapingTableData {
  websites: string
  description: string
  time: string
  duration: string
  status: string
  pages: string
  items: string
  qcStatus: string
  qcReview: string
  errors: string
}
interface IWebScrapingCard {
  title: string
  key: string
  value: string
  percentage: number
  icon: string
  warnings?: number
  errors?: number
}
interface IMonthlyStaticOption {
  value: number
  label: string | number
}
interface IIssueTrackerColumn {
  id:
    | "serial_no"
    | "date"
    | "usecase"
    | "pipelineName"
    | "pipelineId"
    | "issueDetail"
    | "reportedBy"
    | "aiAgentInvestigation"
  label: string
  minWidth?: number
  align?: "left" | "right" | "center"
  format?: (value: number) => string
}
interface IQualityCheck {
  schema_check: boolean
  drift_check: boolean
  data_check: boolean
}

interface IRawDataObject {
  table_name: string
  total_number_of_column: number
  average_count_of_rows: number
  quality_check: IQualityCheck
}

interface IRawDataInterface {
  rawData: IRawDataObject[]
  rawDataStatus: string
  error: string
}

// interface IRuleResult {
//   Column: string
//   Error_Description: string
//   Total_Count: number
//   Violation_Count: number
//   Violation_Percentage: number
// }

interface IRulePipelineStatus {
  PIPELINE_RUN_ID: string
  TABLE: string
  RULE_TITLE: string
  RULE_DESCRIPTION: string
  RULE_COLUMNS_TO_APPLY: string
  SQL_QUERY: string
  PROGRESS: string
  TYPE: string
  SQL_EXECUTION_STATUS: string
  RESULT: any
}

interface IActiveReportModal {
  status: boolean
  qualityTypeId: string | null
}
interface IGenAiRules {
  "Rule Title": string
  Description: string
  Implementation: string
  Columns_to_apply: string
  Conditions: string
}

interface IExistingRules {
  table_name: string
  existing_rules: string
  condition: number
}

interface IDataQualityRules {
  genAiRules: IGenAiRules[]
  existingRules: IExistingRules[]
  dataqualityRulesStatus: string
  GenAiRulesStatus: string
  ImplementedRulesStatus: string
  selectedAiGeneratedRules: IGenAiRules[]
  selectedExistingRules: IExistingRules[]
  dataset: string
  error: string
}
interface IBusinessQualityRules {
  genAiRules: IGenAiRules[]
  existingRules: string[]
  dataqualityRulesStatus: string
  selectedAiGeneratedRules: IGenAiRules[]
  selectedExistingRules: IExistingRules[]
  dataset: string
  error: string
}

interface IAiRulesModalData {
  configuration: {
    dataset: string
    description: string
    columnsToApply: string
  }
}

interface IManualRulesModalData {
  dataset: string
  description: string
  columnsToApply: string
}

interface IDataQualityState {
  activeReportModal: IActiveReportModal
  dataQualityConfigModal: boolean
  businessQualityConfigModal: boolean
  navigationHistory: string[]
  refreshHit: number
  overViewData: typeof sampleData
  activeQualityTypeReport: string | number | null
  rawData: IRawDataInterface
  selectedDataSet: string
  dataQualityRules: IDataQualityRules
  businessQualityRules: IBusinessQualityRules
  aiRulesModalData: IAiRulesModalData
  manualRulesModalData: IManualRulesModalData
  runQCCheck: string
  runId: string | null
  rulePipelineStatus: IRulePipelineStatus[]
  rulesAddedtoPipeline: IRulePipelineStatus[]
  rulePipelineStatusLoading: string
  refreshStatus: string
}
export type {
  IWebScrapingColumn,
  IChildMenuItem,
  IAlertStatus,
  IMetaDataCard,
  IFeatureDriftCard,
  IAdmTableColumn,
  IModelMetaDataColumn,
  IModelMetaData,
  IAdmTableData,
  IISQTableColumn,
  IDDCTableColumn,
  IDDCTableTableData,
  IISQTableData,
  ICCTableData,
  ICCTableColumn,
  IFeatureDriftTableData,
  IFeatureDriftTableColumn,
  IParentMenuItem,
  INavigationMenu,
  IMonitorCardInterface,
  IGantChartSeriesDataType,
  IGantData,
  IPipelineData,
  IWorkflow,
  IUseCaseOptions,
  IImageProps,
  IDropDownOptions,
  INewPipeLineTab,
  IAzureMonitorUsageObj,
  IClusterMemoryChartData,
  INewPipeLineObj,
  INewPipeLineColumn,
  IDeepDiveData,
  INewTableCellChangePayload,
  IParameter,
  IRawDataQuality,
  IISPRTableColumn,
  IISPRTableData,
  IWebScrapingTableData,
  IModelMetaDataCard,
  IWebScrapingCard,
  IRawDataDetailsTableColumn,
  IMaintenanceColumn,
  IMaintenanceRunColumn,
  IMaintenanceExecutionData,
  IStatus,
  IMonthlyStaticOption,
  IIssueTrackerColumn,
  IQualityCheck,
  IRawDataObject,
  IRawDataInterface,
  IRulePipelineStatus,
  IActiveReportModal,
  IGenAiRules,
  IExistingRules,
  IDataQualityRules,
  IBusinessQualityRules,
  IAiRulesModalData,
  IManualRulesModalData,
  IDataQualityState,
}
export enum Screen {
  Default,
  ViewMore,
  MoreDetails,
}

export enum PipelineStatusCodes {
  SUCCESS = 3,
  FAILURE = 0,
  RUNNING = 1,
  UNKNOWN = 2,
  SCHEDULED = 4,
}

export interface ITask {
  id: string
  type: TaskType
  name: string
  start: Date
  end: Date
  toolTipName?: string
  /**
   * From 0 to 100
   */
  progress: number
  styles?: {
    backgroundColor?: string
    backgroundSelectedColor?: string
    progressColor?: string
    progressSelectedColor?: string
  }
  isDisabled?: boolean
  project?: string
  dependencies?: string[]
  hideChildren?: boolean
  displayOrder?: number
  scheduled?: boolean
  status: number
}
